import gsap from "gsap";

/**
 * Win animation for anubis_slot symbols.
 * Pulse effect: scale down → scale up → back to normal.
 */
export function symbolWin(symbol, { timeScale = 1, skip = false } = {}) {
    const tl = gsap.timeline();
    const body = symbol.find("body");
    if (!body || skip) return tl;

    tl.to(body.scale, {
        x: 0.85, y: 0.85,
        duration: 0.15 / timeScale,
        ease: "power2.in",
    });
    tl.to(body.scale, {
        x: 1.1, y: 1.1,
        duration: 0.2 / timeScale,
        ease: "back.out(2)",
    });
    tl.to(body.scale, {
        x: 1, y: 1,
        duration: 0.15 / timeScale,
        ease: "power1.out",
    });

    return tl;
}
